module.exports = __webpack_public_path__ + "img/t6-teal.e8b6d72a.png";